import { Scene } from "phaser";

export default class About extends Scene {

    constructor() {
        super({ key: "About" });
    }

    init() {

        this.textHelp = `This project was made with love by two anonymous fans, inspired by the amazing K-pop group Dreamcatcher. It is a non-profit fan project, and we do not ask for or accept money in any way.

        We created this as a tribute to Dreamcatcher and to share our appreciation with others. If you have any questions or need help, you can contact us at contact@deukae.com.

        Thank you for your support, and we hope you enjoy the project as much as we enjoyed creating it!`;
    }

    preload() {
    
        if (this.sys.game.device.os.desktop) {
            this.isMobile = false;
        }
        else {
            this.isMobile = true;
        }


    }
    create() {

        const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        const screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 2;

        this.cameras.main.setBackgroundColor('#333333');

        const w = this.textures.get('backgroundSettings').getSourceImage().width;
        const h = this.textures.get('backgroundSettings').getSourceImage().height;

        let scaleX = this.cameras.main.width / w;
        let scaleY = this.cameras.main.height / h;
        let scale1 = Math.max(scaleX, scaleY)
        this.imageBackground = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, `backgroundSettings`).setScale(scale1).setScrollFactor(0);


        this.imagePause = this.add.image((screenCenterX /2) - 60, (screenCenterY/ 2) - 60, `menu-pause`).setScale(3.5).setOrigin(0, 0).setScrollFactor(0);

        this.textPausa = this.add.bitmapText(screenCenterX + 5, screenCenterY - 40, 
            'pixelfont', "about".toUpperCase(), 20, 1).setTint(0xffffff).setDepth(1).setOrigin(0.5);
        this.textHome = this.add.bitmapText(screenCenterX , screenCenterY + 40, 
            'pixelfont', this.textHelp.toUpperCase(), 10, 1).setTint(0xffffff).setDepth(1).setOrigin(0.5).setVisible(true).setMaxWidth(screenCenterX + 70)

        this.cancel = this.add.image(screenCenterX, screenCenterY + 125, 'cancel').setScale(1).setInteractive({ useHandCursor: true }).setVisible(true).setDepth(1);

        this.cancel.on('pointerdown', () => {
            this.cancel.setAlpha(0.4)
        }).on('pointerup', () => {
            this.cancel.setAlpha(1)
            this.textPausa.visible = true;
            this.scene.stop();
            this.scene.start(`Start`);

        });

        
    }
    
    update() {


    }


}